module.exports = __webpack_public_path__ + "img/imgYLSYB(5).0c5d5060.png";